/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import baseTheme from './baseTheme';

export const zIndex = {
  ...baseTheme.zIndex,
};

export default zIndex;
